<template>
  <div class="d-flex justify-content-center align-items-center">
    <form class="login-form">
      <div class="card mb-0">
        <div class="card-body">
          <div class="text-center mb-3">
            <img
              src="@/assets/img/logos/logo_mini.png"
              class="h-72px"
              alt="Logo"
            />
            <h5 class="mt-1 mb-0">Portal de Relatórios</h5>
          </div>
          <div class="text-center">
            <p v-if="!error">
              <i class="ph ph-spinner spinner" />
            </p>
            <div v-else>
              <p class="mb-3">
                Erro ao autenticar <br />
                {{ error }}
              </p>
            </div>
            <router-link to="/" class="btn btn-dark" title="Voltar">
              Voltar
            </router-link>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import PATHS from '@/router/routesMap'

export default {
  name: 'Callback',

  data() {
    return {
      error: null,
    }
  },

  methods: {
    async signInMicrosoft(code) {
      try {
        await this.$store.dispatch('signInMicrosoft', {
          code,
        })
        this.$router.push(PATHS.HOME)
      } catch (error) {
        if (error && error.message) {
          this.error = error.message
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.error = 'Não foi possível se conectar ao servidor'
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  async created() {
    const params = new URLSearchParams(window.location.search)

    const code = params.get('code')
    const error = params.get('error')

    if (!code) {
      this.error = 'Código de autorização não encontrado.'
      return
    }

    if (error) {
      this.error = error
      return
    }

    try {
      this.signInMicrosoft(code)
    } catch (err) {
      this.error = err.response?.data?.error || 'Erro desconhecido.'
    }
  },
}
</script>
